import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./AwardsLastBanner.css";
import "../../MissionAndVission/MissionContact/MissionContact.css";
const AwardsLastBanner = () => {
  return (
    <>
      <div className="mission-contact mt-md-5 mt-4 ew-lastbanner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="headings contact-h1 text-white">
                <span className="contact-h1-span">Partner with Our</span>{" "}
                award-winning travel company
              </h1>
              <p className="mission-contact-p">
                Experience the power of premium, personalized, and hassle-free
                travel management with our globally recognized services.
              </p>
              <div className="carouselCaption">
                <a href="/contact">
                  <button className="btn bg-transparent text-white  text-uppercase mt-md-3 grotesk-headings fw-bold">
                    Start Your Journey
                  </button>
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-image-m award-last-img">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/awardlast.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AwardsLastBanner;
